import React, { Component } from 'react'
import { connect } from 'react-redux'

import { phaseChange, storeRestoreInit } from '../../../actions/Buy'
import BuyModal from '../dumb/BuyModal'
import BuyPleaseWait from '../dumb/BuyPleaseWait'

class Restore extends Component {
  componentDidMount() {
    this.props.phaseChange({ phase: -1 })
    this.props.storeRestoreInit({
      id_ordine: this.props.params.id_ordine,
      id_token: this.props.params.id_token,
    })
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.error.display === true &&
      this.props.error.display === false
    ) {
      /**
       * BRUM-6021 se l'utente becca un errore
       * durante restore e chiude il popup
       * rimarrebbe stuccato "stiamo recuperando"
       * allora preferiamo rimandarlo al register
       */
      window.location.href = `/${this.props.id_auto}`
    }
  }

  render() {
    return (
      <BuyModal>
        <BuyPleaseWait
          h1="Stiamo recuperando il tuo ordine!"
          p={<span></span>}
        />
      </BuyModal>
    )
  }
}

const mapStateToProps = state => ({
  error: state.error,
  id_auto: state.product.id_auto,
})

export default connect(mapStateToProps, {
  phaseChange,
  storeRestoreInit,
})(Restore)
